import script from "./RelatedVenues.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedVenues.vue?vue&type=script&setup=true&lang=js"

import "./RelatedVenues.vue?vue&type=style&index=0&id=209994e9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209994e9"]])

export default __exports__